module.exports = __webpack_public_path__ + "img/5-1.e300d6ac.jpg";